module.exports = __webpack_public_path__ + "static/cr-2e30421c21b1dcd4aa924d9eabfaed2b.png";